<div class="asset-summary-pop-up">
    <div class="adjust">
        <div class="arrow-up"></div>
    </div>
    <div class="baloon">
        <asset-summary [data]='symbol' [showClose]="showClose"></asset-summary>
    </div>
    <button disableWksChange class="button-plus-modal" (click)="addItemToWorkspace()" mat-mini-fab
      matTooltipPosition="above" [matTooltip]="addInWksTooltip">+
    </button>
</div>
